export function convertToEntityWithInstitution(entity) {
  return {
    ...entity,
    institution: {
      name: entity.institutionName,
      shortName: entity.institutionShortName,
      id: entity.institutionId,
    },
  };
}
